document.addEventListener('cart:updated', function(evt) {
  const jewelboxElement = document.querySelector("#jewelry_box");
  if (evt.detail.cart.item_count >= 2) {
    jewelboxElement.style.display = "block";
  } else {
    jewelboxElement.style.display = "none";
  }
});


document.addEventListener('ajaxProduct:added', function(evt) {
   $.ajax({
      type: 'GET',
      url: Shopify.routes.root + 'cart.js',
      async: true,
      success: (cart) => {
        const jewelboxElement = document.querySelector("#jewelry_box");
        const cartData = JSON.parse(cart);
        if (cartData.item_count >= 2) {
          jewelboxElement.style.display = "block";
        } else {
          jewelboxElement.style.display = "none";
        }
      }
    });
});

// Low Stock Indicator - Update based on variant change
(function() {
  function updateLowStockIndicator(evt) {
    var indicator = document.querySelector('[data-low-stock-indicator]');
    
    if (!indicator) {
      return;
    }
    
    var variant = evt && evt.detail ? evt.detail.variant : null;
    
    if (!variant || !variant.id) {
      indicator.classList.add('hide');
      return;
    }
    
    // Get data from script tag
    var scriptTag = indicator.parentElement.querySelector('script[data-low-stock-inventory-json]');
    if (!scriptTag) {
      // Try finding in document
      scriptTag = document.querySelector('script[data-low-stock-inventory-json]');
    }
    
    var threshold = parseInt(indicator.dataset.lowStockThreshold || 0, 10);
    var template = indicator.dataset.lowStockTemplate || 'Kun [count] tilbage – skynd dig!';
    
    if (!scriptTag || !scriptTag.textContent) {
      indicator.classList.add('hide');
      return;
    }
    
    // Parse JSON
    var inventoryData;
    try {
      inventoryData = JSON.parse(scriptTag.textContent.trim());
    } catch (e) {
      indicator.classList.add('hide');
      return;
    }
    
    // Get variant info
    var variantIdStr = String(variant.id);
    var variantInfo = inventoryData[variantIdStr] || inventoryData[variant.id];
    
    if (!variantInfo) {
      indicator.classList.add('hide');
      return;
    }
    
    var quantity = parseInt(variantInfo.quantity, 10);
    var tracking = variantInfo.tracking || '';
    var policy = variantInfo.policy || 'deny';
    var available = variantInfo.available !== false;
    
    // Check if we should show
    var shouldShow = Boolean(
      available &&
      tracking === 'shopify' &&
      policy !== 'continue' &&
      quantity > 0 &&
      threshold > 0 &&
      quantity <= threshold
    );
    
    // Update text
    var textEl = indicator.querySelector('.product-low-stock__text');
    if (textEl && template) {
      var message = template.replace('[count]', quantity);
      textEl.textContent = message;
    }
    
    // Show or hide
    indicator.classList.toggle('hide', !shouldShow);
  }
  
  function initLowStockIndicator() {
    // Listen to variant change events
    document.addEventListener('variant:change', updateLowStockIndicator);
    
    // Also listen to container-level events if available
    var productContainer = document.querySelector('[data-section-type="product"]');
    if (productContainer) {
      // Use jQuery if available, otherwise use native events
      if (typeof $ !== 'undefined' && $.fn.on) {
        $(productContainer).on('variantChange', updateLowStockIndicator);
      }
    }
    
    // Try to get initial variant from URL or form
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    
    if (variantId) {
      // Get variant data from script tag
      var scriptTag = document.querySelector('script[data-low-stock-inventory-json]');
      if (scriptTag) {
        try {
          var inventoryData = JSON.parse(scriptTag.textContent.trim());
          var variantInfo = inventoryData[variantId] || inventoryData[String(variantId)];
          if (variantInfo) {
            updateLowStockIndicator({
              detail: {
                variant: {
                  id: variantId,
                  available: variantInfo.available,
                  inventory_management: variantInfo.tracking,
                  inventory_policy: variantInfo.policy
                }
              }
            });
          }
        } catch (e) {
          // Silently fail if initialization error
        }
      }
    }
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLowStockIndicator);
  } else {
    // DOM already ready
    initLowStockIndicator();
  }
})();